import React from 'react';
import './index.css';

interface P {
    onClick?: any
    label?: string
}

export default ({onClick, label}: P) => {
    return(
        <div {...{onClick}} className={`scroll-up-btn ${label ? 'with-label' : ''}`}>
            <div className={`scroll-up-chevron`}>
                <svg width="16" height="10" viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="1,9 8,2 15,9" fill="none" strokeWidth="2" className="scroll-up-arrow"/>
                </svg>
            </div>
            {label && <span className={`scroll-up-label non-selectable`}>{label}</span>}
        </div>
    )
}
